import React from 'react';
import { Chart } from '../../components/Chart';
import { Table } from '../../components/Table';
import { useTheme } from '../../contexts/ThemeContext';

export const ProductRatingPage: React.FC = () => {
  const { theme } = useTheme();

  return (
    <div className={`content-section ${theme.isDark ? 'dark' : 'light'}`}>
      <h2>Рейтинг товаров</h2>
      <div style={{ display: 'flex', gap: '20px', marginBottom: '20px' }}>
        <Chart
          theme={theme}
          type="bar"
          title="Продажи по категориям"
          data={[
            { label: 'Хлеб', value: 1245, color: '#003497' },
            { label: 'Молоко', value: 987, color: '#4d7fff' },
            { label: 'Мясо', value: 756, color: '#80a3ff' },
            { label: 'Овощи', value: 634, color: '#b3ccff' }
          ]}
        />
        <Chart
          theme={theme}
          type="pie"
          title="Доля категорий в общей выручке"
          data={[
            { label: 'Хлебобулочные', value: 24900, color: '#003497' },
            { label: 'Молочные', value: 49350, color: '#4d7fff' },
            { label: 'Мясные', value: 37800, color: '#80a3ff' },
            { label: 'Продукты', value: 38040, color: '#b3ccff' }
          ]}
        />
      </div>
      <Table
        title="ТОП-10 товаров по продажам"
        columns={[
          { key: 'rank', title: 'Место', width: '10%' },
          { key: 'name', title: 'Название товара', width: '40%' },
          { key: 'sold_count', title: 'Продано шт.', width: '15%' },
          { key: 'revenue', title: 'Выручка, сом', width: '20%' },
          { key: 'category', title: 'Категория', width: '15%' }
        ]}
        data={[
          { id: '1', rank: '1', name: 'Хлеб белый 500г', sold_count: '1,245', revenue: '24,900', category: 'Хлебобулочные', is_deleted: false },
          { id: '2', rank: '2', name: 'Молоко 1л', sold_count: '987', revenue: '49,350', category: 'Молочные', is_deleted: false },
          { id: '3', rank: '3', name: 'Масло сливочное 200г', sold_count: '756', revenue: '37,800', category: 'Молочные', is_deleted: false },
          { id: '4', rank: '4', name: 'Сахар 1кг', sold_count: '634', revenue: '38,040', category: 'Продукты', is_deleted: false },
          { id: '5', rank: '5', name: 'Макароны 400г', sold_count: '523', revenue: '15,690', category: 'Макаронные', is_deleted: false }
        ]}
        theme={theme}
        readOnly={true}
      />
    </div>
  );
};
